import {Injectable} from '@angular/core';
import {ObservableRequestService} from '../../services/observable-request.service';
import {ConstantsService} from '../../services/constants-service';
import {Headers} from '@angular/http';
import {DataImportedReview} from './dataImported.model';

@Injectable()
export class ImportController {

  constructor(public requestService: ObservableRequestService) {
  }

  public reviewDataToImport(File: any, password: string) {
    const formData = new FormData();
    formData.append('file', File);
    const url = `${ConstantsService.REVIEW_DATA_TO_IMPORT_ENDPOINT}${password && password !== '' ? '?password=' + password : ''}`;
    const headers = new Headers();
    return this.requestService.postRequest(url, formData, headers, 3600000).map((response) => response.arrResult);
  }

  saveImport(data: DataImportedReview) {
    const headers = new Headers();
    return this.requestService.postRequest(`${ConstantsService.SAVE_DATA_TO_IMPORT_ENDPOINT}`, data, headers, 3600000 )
      .map((response) => response.arrResult);
  }

  // ==================== Session Management Methods ====================
  
  /**
   * Load active import session
   */
  getActiveSession() {
    return this.requestService.getRequest(ConstantsService.GET_ACTIVE_SESSION_ENDPOINT)
      .map((response) => response.arrResult);
  }

  /**
   * Create or replace active session
   */
  createOrReplaceSession(dataReview: DataImportedReview, excelFileName: string) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const sessionData = {
      dataReview: dataReview,
      excelFileName: excelFileName
    };
    return this.requestService.postRequest(ConstantsService.CREATE_OR_REPLACE_SESSION_ENDPOINT, sessionData, headers, 30000)
      .map((response) => response.arrResult);
  }

  /**
   * Update active session
   */
  updateSession(dataReview: DataImportedReview) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    const sessionData = {
      dataReview: dataReview
    };
    return this.requestService.putRequest(ConstantsService.UPDATE_SESSION_ENDPOINT, sessionData, headers)
      .map((response) => response.arrResult);
  }

  /**
   * Build session from Excel file (replaces existing session data)
   */
  buildSessionFromExcel(file: any, password: string) {
    const formData = new FormData();
    formData.append('file', file);
    const url = `${ConstantsService.BUILD_SESSION_FROM_EXCEL_ENDPOINT}${password && password !== '' ? '?password=' + password : ''}`;
    const headers = new Headers();
    return this.requestService.postRequest(url, formData, headers, 3600000)
      .map((response) => response.arrResult);
  }

  /**
   * Auto-map counterparties using backend matching algorithm
   */
  autoMapCounterparties(dataReview: DataImportedReview) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return this.requestService.postRequest(ConstantsService.AUTO_MAP_COUNTERPARTIES_ENDPOINT, dataReview, headers, 3600000)
      .map((response) => response.arrResult);
  }

  /**
   * Auto-map clients that have exists=true but are missing mappedClientId and mappedClientName
   */
  autoMapClients(dataReview: DataImportedReview) {
    const headers = new Headers();
    headers.append('Content-Type', 'application/json');
    return this.requestService.postRequest(ConstantsService.AUTO_MAP_CLIENTS_ENDPOINT, dataReview, headers, 3600000)
      .map((response) => response.arrResult);
  }

}



// WEBPACK FOOTER //
// ./src/app/admin/import/import.controller.ts